import { icons } from 'src/assets/iconDef/icon.def';

export const orderMenuDef = [
    {
        name: 'menu.patient_portal',
        icon: 'fa fa-calendar',
        children: [
            {
                name: 'menu.book_appointment',
                icon: 'fa fa-calendar',
                resource: 'appointment_patient',
                url: 'add-appointment',
                auto_crud: true,
                breadcrumb: 'Appointment',
            },
            {
                name: 'menu.appointment',
                icon: 'fa fa-calendar',
                resource: 'service_request',
                url: 'service_request',
                auto_crud: true,
                showMenu: false,
                breadcrumb: 'Appointment',
                check_permission: false
            }
        ]
    },
    {
        name: 'menu.appointment',
        icon: 'fa fa-calendar',
        resource: 'service_request',
        url: 'service_request',
        auto_crud: true,
        showMenu: false,
        breadcrumb: 'Appointment',
        check_permission: false
    },
    {
        "name": "menu.finance_clearnance_procedure",
        "resource": "finance_clearnance_procedure",
        "icon": "fa fa-user",
        "url": "finance_clearnance_procedure",
        "auto_crud": true,
        "breadcrumb": "Finance Clearance",
        "showMenu": false
      },
    {
        "resource": "immunization_master",
        "url": "immunization_master",
        "auto_crud": true,
        "showMenu": false,
    },
    {
        "resource": "immunization_details",
        "url": "immunization_details",
        "auto_crud": true,
        "showMenu": false,
    },
    {
        "name": "menu.emr",
        "icon": "fa fa-plus-square",
        "data": {
            "nav_url": "casesheet_master_m"
        },
        "children": [
            {
                name: 'menu.immunization_admission_vaccine_details',
                resource: 'immunization_admission_vaccine_details',
                icon: 'fa fa-superpowers',
                url: 'immunization_admission_vaccine_details',
                auto_crud: true,
                breadcrumb: 'immunization_admission_vaccine_details'
            }
        ]
    },
    {
        "name": "menu.care_plan_patient_list",
        "resource": "care_plan_patient_list",
        "icon": "fa fa-user-md",
        "url": "care_plan_patient_list",
        "auto_crud": true,
        "showMenu": false
    },
    {
        "name": "menu.care_plan_request_details",
        "resource": "care_plan_request_details",
        "icon": "fa fa-user-md",
        "url": "care_plan_request_details",
        "auto_crud": true,
        "showMenu": false
    },
    {
        "name": "menu.notification_criteria",
        "resource": "notification_criteria",
        "icon": "fa fa-user-md",
        "url": "notification_criteria",
        "auto_crud": true,
        "showMenu": false
    }


]
